import * as React from "react";
const useIsoLayoutEffect = typeof window === "undefined" ? React.useEffect : React.useLayoutEffect;
function joinIds(...ids) {
  const joined = ids.filter(Boolean).join(" ").trim();
  return joined === "" ? void 0 : joined;
}
function hasContent(node) {
  return node !== void 0 && node !== null && node !== false && node !== true && node !== "";
}
export {
  hasContent,
  joinIds,
  useIsoLayoutEffect
};
//# sourceMappingURL=internal.js.map
